<template>
  <div class="general-notification">
    <!--<el-tag
      type="danger"
    >ATTENTION: Rankings of September 9th will be used for Main Draw Acceptance into Linz, Tianjin, Moscow and Luxembourg</el-tag>-->
  </div>
</template>

<style scoped>
.general-notification {
  margin-bottom: 10px;
  width: 100%;
}
</style>

<script>
export default {
  data() {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// src/widgets/GeneralNotifications.vue